// @need-translate
import {t} from '../../../common/getTranslations';
import {ButtonV2Variant} from '../../atoms/ButtonV2/ButtonV2.enum';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {Dialog} from '../Dialog';
import {AppLinkDialogProps} from './AppLinkDialogProps';

export function AppLinkDialog({
  isOpen,
  onClickAppLinkButton,
  onClickMobileWebButton,
  isMobile,
  onClose,
}: AppLinkDialogProps) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} isMobile={isMobile}>
      <Dialog.Dimmed />
      <Dialog.List className="space-y-0 pt-4pxr px-24pxr pb-0">
        <Dialog.Image imageType={StaticImageType.ModalAppIconStatic} />
        <Dialog.Title className="px-28pxr pb-16pxr">
          {t('web_appdownload_popup_title')}
        </Dialog.Title>
      </Dialog.List>
      <Dialog.List className="space-y-8pxr px-24pxr pt-4pxr pb-36pxr">
        <Dialog.Button
          onClick={onClickAppLinkButton}
          className="font-medium1-bold"
          variant={ButtonV2Variant.Primary}
        >
          {t('web_appdownload_popup_button')}
        </Dialog.Button>
        <Dialog.Label
          onClick={onClickMobileWebButton}
          className="cursor-pointer text-theme-solid-60 font-small1 h-32pxr flex items-center justify-center"
        >
          {t('web_appdownload_popup_subtitle')}
        </Dialog.Label>
      </Dialog.List>
    </Dialog>
  );
}
